import Vue from 'vue'
import App from './App.vue'
import VueQrcodeReader from "vue-qrcode-reader";

require('./assets/sass/main.scss');

Vue.config.productionTip = false
Vue.use(VueQrcodeReader)

Vue.directive('title', {
  inserted: (el, binding) => document.title = binding.value,
  update: (el, binding) => document.title = binding.value
})

new Vue({
  render: h => h(App),
}).$mount('#app')
